import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../supabaseClient";
//can we get vercel to update?

export function useUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (error) {
        console.error("Error fetching user:", error);
        setUser(null);
        setLoading(false);
        return;
      }

      if (user) {
        supabase
          .from("profiles")
          .select("*")
          .eq("id", user.id)
          .then(({ data, error }) => {
            if (error) {
              console.error("Error fetching user profile:", error);
              setUser(null);
            } else {
              if (data.length === 0) {
                setUser(null);
              } else {
                setUser(data[0]);
              }
            }
            setLoading(false);
          });
      } else {
        setUser(null);
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    if (!loading && user === null) {
      navigate("/"); // Redirect to root page if user is null
    }
  }, [user, loading, navigate]);

  return { user, loading };
}
